export default "__VITE_ASSET__CravB1F7__"